import "src/decidim/forms/forms"

// CSS
import "stylesheets/decidim/forms/forms.scss"

// Images
require.context("../images", true)
